import { GlobalEmailTypes } from '../constants-types/Enums';
import { Language } from '../shared/Language.model';
import { AssessmentAdministrator } from './AssessmentAdministrator.model';

// HISTORY: Notes on the history of this object. Originally, the email deatils did nto know what kind of email
// it represented, but later it needed to in order to reset itself so this was added.

export class EmailDetails {
    subject = '';
    message = '';
    // this is technically what was last loaded and not an analysis of text
    languageOfSubject: string;
    languageOfMessage: string;
    language: Language;
    administrator: AssessmentAdministrator;
    assessmentExpirationDate: Date;
    type: GlobalEmailTypes;
    sendAnalystCompletionEmail: boolean;

    constructor(type: GlobalEmailTypes) {
        this.administrator = new AssessmentAdministrator();
        this.language = new Language();
        this.type = type;
    }
}
